
var CgProduct = {

    init: function()
    {

        var me = this;
        me.initTabs();
        me.initSimulation();
        me.initLowStockMessage();
        me.initRelatedProducts();
        me.initSlider();
        me.initMobileGalleryCounter();
        me.watchGallery();
        me.initFloatingATC();


        // $("#floating_atc .product-form__submit").on("click", function(e){
        //     e.preventDefault();
        //     $(".product__info-container .prod-form-wrap form [type='submit']").click();
        //     return false;
        // });

    },


    initTabs: function()
    {

        var to = null;

        $(".cg-product-tabs .tab-link").on("click", function(e){

            e.preventDefault();
            clearTimeout(to);
            var elem = $(this);
            var target = $(".tab-wrap " + elem.attr("href"));

            if(elem.hasClass("active")){
                elem.removeClass("active");
                target.removeClass("active");
                target.removeClass("animated");
            }else{
                elem.addClass("active");
                target.addClass("active");
                to = setTimeout(function(){
                    target.addClass("animated");
                }, 800);
            }

        });


        var mq = window.matchMedia('(max-width: 991px)');
        if(mq.matches){
            
            $(".cg-product-tabs .tab-4-warp .tab-link").addClass("active");
            $(".cg-product-tabs .tab-4-warp .tab-content").addClass("active").addClass("animated");
        }

    },

    // Two gallery layouts share one Slick-driven gallery:
    //   'stacked'          - desktop carousel with its own arrow row and counter,
    //                        unslicked below 750 so Dawn's native scroll slider
    //                        keeps handling mobile.
    //   'thumbnail_slider' - Slick at every breakpoint, wired by index to a
    //                        thumbnail strip, with no numeric counter.
    // Dawn's media-gallery.js stays dormant in both cases: the snippet renders no
    // element whose id starts with "GalleryThumbnails", so its constructor bails out
    // before binding anything and never competes with Slick over the same slides.

    initSlider: function(){

        var me = this;
        var mediaGallery = $("media-gallery").first();
        if(!mediaGallery.length) {
            return;
        }

        var slider = mediaGallery.find(".product__media-list.contains-media").first();
        if(!slider.length) {
            return;
        }

        if(slider.hasClass("slick-initialized")) {
            slider.slick("unslick");
        }

        if(mediaGallery.attr("data-desktop-layout") === "thumbnail_slider") {
            me.initThumbnailGallery(mediaGallery, slider);
        } else {
            me.initStackedGallery(mediaGallery, slider);
        }

    },

    // The gallery markup can be thrown away and re-rendered after load by any
    // number of things: the Theme Editor, `shopify theme dev` syncing, a section
    // re-render on variant change, or an app. The replacement comes straight from
    // the server, so it arrives with no slider attached and looks like the theme's
    // original gallery. Rather than try to intercept every possible cause, watch
    // for a gallery that has lost its slider and rebuild it.
    //
    // Scoped to the thumbnails layout on purpose: there, Slick is initialized at
    // every breakpoint, so "no slick-initialized" always means "needs rebuilding".
    // The stacked layout deliberately unslicks below 750px, so the same check
    // there would rebuild in a loop.
    watchGallery: function(){

        var me = this;
        if(me.galleryObserver || typeof MutationObserver !== "function") {
            return;
        }

        var pending = null;

        var rebuildIfLost = function(){
            pending = null;

            var gallery = document.querySelector('media-gallery[data-desktop-layout="thumbnail_slider"]');
            if(!gallery) {
                return;
            }

            var slider = gallery.querySelector(".product__media-list.contains-media");
            if(!slider || slider.classList.contains("slick-initialized")) {
                return;
            }

            me.initSlider();
        };

        me.galleryObserver = new MutationObserver(function(){
            if(pending) {
                return;
            }
            pending = window.setTimeout(rebuildIfLost, 150);
        });

        me.galleryObserver.observe(document.body, { childList: true, subtree: true });

    },

    initStackedGallery: function(mediaGallery, slider){

        var me = this;

        var sliderArrowsWrap = slider.closest("slider-component").find(".slider-arrows-wrap").first();
        if(!sliderArrowsWrap.length) {
            return;
        }

        sliderArrowsWrap.empty();

        var prevArrowSrc = sliderArrowsWrap.data("arrow-prev");
        var nextArrowSrc = sliderArrowsWrap.data("arrow-next");


        slider.off('init.cgProductSlider reInit.cgProductSlider afterChange.cgProductSlider');
        slider.on('init.cgProductSlider reInit.cgProductSlider afterChange.cgProductSlider', function(event, slick, currentSlide, nextSlide){
            var i = (currentSlide ? currentSlide : 0) + 1;
            sliderArrowsWrap.find('.slide-num').text(i + '/' + slick.slideCount);
        });

        // Fires during .slick() below (and covers the mobile carousel path).
        slider.one('init.cgReveal', function(){
            me.revealGallery(mediaGallery, slider);
        });

        slider.slick({
            rtl: true,
            slide: ".product__media-item",
            arrows: true,
            appendArrows: sliderArrowsWrap,
            prevArrow: `<button class='arrow arrow-prev'><img class='arrow-img prev' src="${prevArrowSrc}" /></button>`,
            nextArrow: `<div class='slide-num'></div><button class='arrow arrow-next'><img class='arrow-img next' src="${nextArrowSrc}" /></button>`,
            responsive: [
                {
                    breakpoint: 750,
                    settings: "unslick"
                }
            ]
        });

        // On desktop Slick immediately unslicks (breakpoint 750 -> "unslick"), so
        // the persistent 'init' handler may not run — reveal directly here too.
        // revealGallery is idempotent, so it never double-fires.
        me.revealGallery(mediaGallery, slider);

    },

    // No loading mask here: the CSS renders the server-side markup as its final
    // shape (first slide only, thumbnails in a row), so the gallery is correct
    // before any JavaScript runs and Slick only enhances it.
    initThumbnailGallery: function(mediaGallery, slider){

        var me = this;
        var thumbsWrap = mediaGallery.find("[data-gallery-thumbnails]").first();
        var thumbs = thumbsWrap.find(".thumbnail-list").first();

        slider.slick({
            rtl: true,
            slide: ".product__media-item",
            arrows: false,
            infinite: false,
            adaptiveHeight: false
        });

        // Single-media products render no strip — nothing to wire up.
        if(!thumbs.length) {
            return;
        }

        if(thumbs.hasClass("slick-initialized")) {
            thumbs.slick("unslick");
        }

        // Slick's own `responsive` option is not used here: it reads
        // window.innerWidth, which can disagree with the CSS viewport at the
        // moment the deferred scripts run (device emulation, in-app browsers),
        // and its resize guard then never re-checks — the strip gets stuck with
        // the desktop slide count on mobile. matchMedia is the same source of
        // truth the stylesheet uses, so JS and CSS can never disagree.
        var mobileQuery = window.matchMedia("(max-width: 749px)");
        var thumbsPerView = function(){
            return mobileQuery.matches ? 4 : 5;
        };

        thumbs.slick({
            rtl: true,
            slide: ".thumbnail-list__item",
            arrows: false,
            infinite: false,
            slidesToShow: thumbsPerView(),
            slidesToScroll: 1
        });

        // Re-apply the per-view count when the breakpoint flips. The previous
        // listener is dropped first (from the MediaQueryList it was added to —
        // matchMedia returns a fresh object per call) so re-inits (Theme Editor,
        // watchGallery) don't stack handlers bound to dead slider instances.
        if(me.thumbsBreakpointQuery && me.thumbsBreakpointHandler) {
            me.thumbsBreakpointQuery.removeEventListener("change", me.thumbsBreakpointHandler);
        }
        me.thumbsBreakpointQuery = mobileQuery;
        me.thumbsBreakpointHandler = function(){
            if(!thumbs.hasClass("slick-initialized")) {
                return;
            }
            var perView = thumbsPerView();
            if(thumbs.slick("getSlick").options.slidesToShow !== perView) {
                thumbs.slick("slickSetOption", "slidesToShow", perView, true);
            }
        };
        mobileQuery.addEventListener("change", me.thumbsBreakpointHandler);
        // Some embedded/emulated viewports resize without dispatching the
        // MediaQueryList change event; the resize fallback closes that gap and
        // the value guard above makes the frequent calls a no-op.
        $(window).off("resize.cgThumbsBreakpoint").on("resize.cgThumbsBreakpoint", me.thumbsBreakpointHandler);

        // The two sliders are wired together by hand instead of with Slick's
        // asNavFor. asNavFor has to reconcile rtl and two different slidesToShow
        // values at once and mispairs the indexes; driving them explicitly is
        // both shorter and predictable.

        // `is-active` and `aria-current` are what the rest of the theme and
        // assistive tech read, so mirror Slick's position onto them.
        var setActive = function(index){
            var items = slider.slick("getSlick").$slides;
            var thumbItems = thumbs.slick("getSlick").$slides;

            items.removeClass("is-active");
            items.eq(index).addClass("is-active");

            thumbItems.find(".thumbnail").removeAttr("aria-current");
            thumbItems.eq(index).find(".thumbnail").attr("aria-current", "true");
        };

        // Only scroll the strip when the active thumbnail is actually out of view,
        // so clicking a visible thumbnail doesn't shunt the whole row sideways.
        // The target is clamped to the last valid strip position: a finite Slick
        // rejects slickGoTo past slideCount - slidesToShow outright, so an
        // unclamped call near the end would leave the strip stranded.
        var keepThumbVisible = function(index){
            var state = thumbs.slick("getSlick");
            var first = state.currentSlide;
            var perView = state.options.slidesToShow;

            if(index < first || index >= first + perView) {
                var maxStart = Math.max(0, state.slideCount - perView);
                thumbs.slick("slickGoTo", Math.min(index, maxStart));
            }
        };

        var prevArrow = thumbsWrap.find(".thumb-arrow--prev").first();
        var nextArrow = thumbsWrap.find(".thumb-arrow--next").first();

        // Finite slider: the arrow with nowhere to go gets the native disabled
        // state, which the CSS renders by fading the glyph.
        var updateArrows = function(index){
            var last = slider.slick("getSlick").slideCount - 1;
            prevArrow.prop("disabled", index <= 0);
            nextArrow.prop("disabled", index >= last);
        };

        // The active border, the strip scroll and the arrow states react on
        // beforeChange — the moment navigation starts — so the thumbnails
        // respond instantly instead of waiting out the main image's slide
        // animation. Only pausing media stays on afterChange.
        slider.off("beforeChange.cgThumbs afterChange.cgThumbs");
        slider.on("beforeChange.cgThumbs", function(event, slick, currentSlide, nextSlide){
            setActive(nextSlide);
            keepThumbVisible(nextSlide);
            updateArrows(nextSlide);
        });
        slider.on("afterChange.cgThumbs", function(){
            if(typeof window.pauseAllMedia === "function") {
                window.pauseAllMedia();
            }
        });

        thumbs.off("click.cgThumbs").on("click.cgThumbs", ".thumbnail-list__item", function(event){
            event.preventDefault();
            var index = $(this).data("slick-index");
            if(index === undefined || index === null) {
                return;
            }
            slider.slick("slickGoTo", parseInt(index, 10));
        });

        // The arrows page the main image; the strip follows through the
        // beforeChange handler above, same as a thumbnail click or a swipe.
        prevArrow.off("click.cgThumbs").on("click.cgThumbs", function(){
            slider.slick("slickPrev");
        });
        nextArrow.off("click.cgThumbs").on("click.cgThumbs", function(){
            slider.slick("slickNext");
        });

        setActive(slider.slick("slickCurrentSlide"));
        updateArrows(slider.slick("slickCurrentSlide"));

    },

    // Stacked layout only. Its slides size to each image's own aspect ratio, so
    // the gallery is masked until the active image is painted, otherwise the
    // reveal shifts the page. The thumbnails layout needs none of this — its
    // slides are ratio-locked in CSS, so it renders correctly without JS.
    revealGallery: function(mediaGallery, slider){

        if(mediaGallery.data("cgRevealScheduled")) {
            return;
        }
        mediaGallery.data("cgRevealScheduled", true);

        var unmask = function(){
            if(slider.hasClass("slick-initialized")) {
                try { slider.slick("setPosition"); } catch(e){}
            }
            // Wait one painted frame after positions are final, then reveal.
            window.requestAnimationFrame(function(){
                window.requestAnimationFrame(function(){
                    mediaGallery.removeClass("is-gallery-loading");
                });
            });
        };

        var img = slider.find(".slick-current img, .product__media-item.is-active img, .product__media-item img").first();
        if(img.length && img.get(0).complete && img.get(0).naturalWidth > 0) {
            unmask();
        } else if(img.length) {
            img.one("load.cgReveal error.cgReveal", unmask);
        } else {
            unmask();
        }

        // Failsafe: never leave the gallery masked if the image/init stalls.
        setTimeout(function(){
            mediaGallery.removeClass("is-gallery-loading");
        }, 3000);

    },

    initMobileGalleryCounter: function(){

        // On mobile the gallery is the native scroll slider (Slick unslicks below
        // 750), and its counter is Dawn's `.slider-counter`. Dawn computes the
        // current slide from `scrollLeft`, which is not RTL-safe, so the number is
        // wrong in this RTL theme. Desktop is unaffected: it uses Slick's own
        // `.slide-num` counter, which is RTL-aware. We recompute the current slide
        // by geometry (nearest slide center to the viewport center), which is
        // correct regardless of text direction.

        var galleryViewer = $("slider-component[id^='GalleryViewer']").first();
        if(!galleryViewer.length) {
            return;
        }

        // The thumbnails layout has no numeric counter — the strip is the indicator.
        if(galleryViewer.closest("media-gallery").attr("data-desktop-layout") === "thumbnail_slider") {
            return;
        }

        var track = galleryViewer.find(".product__media-list.contains-media").first();
        var currentEl = galleryViewer.find(".slider-counter--current").first();
        var totalEl = galleryViewer.find(".slider-counter--total").first();
        if(!track.length || !currentEl.length) {
            return;
        }

        var isMobile = window.matchMedia("(max-width: 749px)");

        var updateCounter = function(){
            if(!isMobile.matches) {
                return; // desktop keeps Slick's own .slide-num counter
            }

            var slides = track.find(".product__media-item").filter(function(){
                return this.clientWidth > 0;
            });
            if(!slides.length) {
                return;
            }

            var viewport = track.get(0).getBoundingClientRect();
            var viewportCenter = viewport.left + viewport.width / 2;
            var current = 1;
            var nearest = Infinity;

            slides.each(function(index){
                var box = this.getBoundingClientRect();
                var slideCenter = box.left + box.width / 2;
                var distance = Math.abs(slideCenter - viewportCenter);
                if(distance < nearest) {
                    nearest = distance;
                    current = index + 1;
                }
            });

            currentEl.text(current);
            if(totalEl.length) {
                totalEl.text(slides.length);
            }
        };

        // Run inside rAF so this writes after Dawn's own scroll handler, making
        // our (correct) value the one that sticks.
        var onScroll = function(){
            window.requestAnimationFrame(updateCounter);
        };

        track.off("scroll.cgGalleryCounter").on("scroll.cgGalleryCounter", onScroll);
        $(window).off("resize.cgGalleryCounter").on("resize.cgGalleryCounter", onScroll);
        updateCounter();

    },

    initLowStockMessage: function(){
        var me = this;
        var inventoryData = JSON.parse($('#product-variant-inventory').html());
        var selectedRadio = $('input[type="radio"][name^="midot carpet dropdown-1"]:checked');
        if (selectedRadio.length > 0) {
            me.updateStockMessage(selectedRadio.val(), inventoryData);
        }

        $(document).on('change', 'input[type="radio"][name^="midot carpet dropdown-1"]', function(e) {
            me.updateStockMessage($(this).val(), inventoryData);
        });

    },

    updateStockMessage: function(optionValue, inventoryData) {
        $(".cg-estimated-delivery").show();
        var variant = inventoryData.variants.find(function(v) {
            return v.option1 === optionValue;
        });
    
        if (variant && variant.inventory_quantity > 0 && variant.inventory_quantity < 10) {
            $('#low-stock-message').text('מהרו, נותרו רק ' + variant.inventory_quantity + ' במלאי!');
        } else {
            $('#low-stock-message').text('');
        }

         if(variant.inventory_quantity == 0) {
            $(".low-stock-message").hide();
            $(".cg-estimated-delivery").addClass('d-none').removeClass("d-flex");
        }else{
            $(".cg-estimated-delivery").removeClass('d-none').addClass("d-flex");
        }


        if(variant.sku) {
            $(".cg-sku-wrap").html(`מק"ט: ${variant.sku}`);
        }
        

    },


    initSimulation: function()
    {

        var defaultURL = 'https://carmelfloor.floori.io/';
        var selectedVariant = $("[data-simulation-sku].selected");

        if(selectedVariant.length) {

            var prod_sku = selectedVariant.attr("data-simulation-sku");
            var newUrl = defaultURL;

            if(prod_sku) {
                newUrl = newUrl + "?sku=" + selectedVariant.attr("data-simulation-sku");
            }
            
            $(".product .simulation-btn").attr("data-simulation", newUrl);

        }else{
            $(".product .simulation-btn").attr("data-simulation", defaultURL);
        }

        $(document).on("click", ".product__info-container .variant-selector label", function(){
            var elem = $(this);
            var prod_sku = elem.attr("data-simulation-sku");
            if(prod_sku) {
                var newUrl = defaultURL + "?sku=" + selectedVariant.attr("data-simulation-sku");
                $(".simulation-btn").attr("data-simulation", newUrl).addClass("has-value");
            }else{
                $(".simulation-btn").attr("data-simulation", defaultURL).removeClass("has-value");
            }
        });

        $(document).on("click", ".product .simulation-btn", function(){
            var rugviewURL = $(this).attr("data-simulation");
            if(rugviewURL) {
                var frame = $(".rugview-frame");
                frame.attr("src", rugviewURL);
                $(".rugview-frame-wrap").addClass("active");
            }
        });

        $(".rugview-frame-wrap .close-btn").on("click", function(){
            $(".rugview-frame-wrap").removeClass("active");
        });

    },


    initRelatedProducts: function(){
        $(".rp-atc-form").on("submit", function(e){
            e.preventDefault();
            var form = $(this)[0];
            var formData = new FormData(form);
            
            fetch('/cart/add', {
                method: 'POST',
                body: formData
            })
            // .then(response => response.json())
            // .then(cart => {
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                for (const selector of selectors) {
                    const targetElement = document.querySelector(selector);
                    const sourceElement = html.querySelector(selector);
                    if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                    }
                }
            });

            return false;
        });
    },

    initFloatingATC: function(){
        var floatingContainer = $("#floating_atc");
        var floatingBtn = $("#floating_atc .floating-btn");
        var floatingInner = floatingBtn.find(".atc-inner");
        var floatingSpinner = floatingBtn.find(".loading__spinner");
        var floatingTextNode = floatingInner.find(".txt").first();
        var floatingIconWrap = floatingInner.find(".ico").first();
        var normalizeLabel = function(value, fallback) {
            var raw = value == null ? "" : String(value);
            var decoded = $.trim($("<div>").html(raw).text());
            return decoded || fallback || "";
        };
        var defaultLabel = normalizeLabel(
            window.variantStrings && window.variantStrings.addToCart,
            $.trim(floatingTextNode.text())
        );
        var buttonObserver = null;
        var observedNode = null;
        var visibilityObserver = null;
        var currentVisibilityTarget = null;

        var findOriginalBtn = function() {
            return $(".prod-form-wrap .product-form__submit").first();
        };

        var isMobileViewport = function() {
            return window.matchMedia("(max-width: 991px)").matches;
        };

        var setFloatingHiddenByMainButton = function(hidden) {
            floatingContainer.toggleClass("is-hidden-by-main-atc", !!hidden);
        };

        var updateFloatingVisibilityByRect = function(targetBtn) {
            if (!targetBtn || !targetBtn.length || !isMobileViewport()) {
                setFloatingHiddenByMainButton(false);
                return;
            }

            var rect = targetBtn[0].getBoundingClientRect();
            var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            var isVisible =
                rect.bottom > 0 &&
                rect.right > 0 &&
                rect.top < viewportHeight &&
                rect.left < viewportWidth;

            setFloatingHiddenByMainButton(isVisible);
        };

        var bindVisibilityTracking = function(targetBtn) {
            $(window).off("scroll.cgFloatingATCVisibility resize.cgFloatingATCVisibility orientationchange.cgFloatingATCVisibility");
            if (visibilityObserver) {
                visibilityObserver.disconnect();
                visibilityObserver = null;
            }

            if (!targetBtn || !targetBtn.length) {
                currentVisibilityTarget = null;
                setFloatingHiddenByMainButton(false);
                return;
            }

            currentVisibilityTarget = targetBtn;

            if ("IntersectionObserver" in window) {
                visibilityObserver = new IntersectionObserver(
                    function(entries) {
                        var entry = entries[0];
                        if (!isMobileViewport()) {
                            setFloatingHiddenByMainButton(false);
                            return;
                        }
                        setFloatingHiddenByMainButton(entry.isIntersecting);
                    },
                    { root: null, threshold: 0.02 }
                );
                visibilityObserver.observe(targetBtn[0]);
                return;
            }

            var fallbackHandler = function() {
                updateFloatingVisibilityByRect(currentVisibilityTarget);
            };
            $(window).on("scroll.cgFloatingATCVisibility resize.cgFloatingATCVisibility orientationchange.cgFloatingATCVisibility", fallbackHandler);
            fallbackHandler();
        };

        var syncFloatingState = function() {
            var originalBtn = findOriginalBtn();
            var originalInner = originalBtn.find(".atc-inner").first();
            var labelText = "";
            var isDisabled = originalBtn.is(":disabled");

            if (!originalBtn.length) {
                floatingBtn.prop("disabled", true).removeClass("loading");
                floatingSpinner.addClass("hidden");
                if (floatingTextNode.length) {
                    floatingTextNode.text(defaultLabel);
                } else if (!$.trim(floatingInner.text())) {
                    floatingInner.text(defaultLabel);
                }
                return null;
            }

            if (originalInner.length) {
                var originalTxt = originalInner.find(".txt").first();

                if (originalTxt.length) {
                    labelText = $.trim(originalTxt.text());
                } else {
                    labelText = $.trim(originalInner.text());
                }
            }

            // Keep floating design stable: only change label for disabled states.
            if (isDisabled) {
                var disabledLabel = normalizeLabel(
                    labelText || (window.variantStrings && (window.variantStrings.soldOut || window.variantStrings.unavailable)),
                    defaultLabel
                );
                if (floatingTextNode.length) {
                    floatingTextNode.text(disabledLabel);
                } else {
                    floatingInner.text(disabledLabel);
                }
                floatingIconWrap.addClass("d-none");
            } else {
                if (floatingTextNode.length) {
                    floatingTextNode.text(defaultLabel);
                } else {
                    floatingInner.text(defaultLabel);
                }
                floatingIconWrap.removeClass("d-none");
            }

            floatingBtn.prop("disabled", isDisabled);

            if (originalBtn.hasClass("loading")) {
                floatingBtn.addClass("loading");
                floatingSpinner.removeClass("hidden");
            } else {
                floatingBtn.removeClass("loading");
                floatingSpinner.addClass("hidden");
            }

            return originalBtn;
        };

        var observeCurrentButton = function() {
            var originalBtn = syncFloatingState();
            if (!originalBtn || !originalBtn.length) {
                bindVisibilityTracking(null);
                return;
            }

            if (observedNode === originalBtn[0]) {
                updateFloatingVisibilityByRect(originalBtn);
                return;
            }

            if (buttonObserver) {
                buttonObserver.disconnect();
            }

            observedNode = originalBtn[0];
            buttonObserver = new MutationObserver(function() {
                syncFloatingState();
            });

            buttonObserver.observe(observedNode, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            });

            bindVisibilityTracking(originalBtn);
        };

        if (floatingBtn.length) {
            observeCurrentButton();

            $(document).on("change", ".prod-form-wrap input[name='id']", function() {
                setTimeout(observeCurrentButton, 0);
            });

            if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.variantChange) {
                subscribe(PUB_SUB_EVENTS.variantChange, function() {
                    setTimeout(observeCurrentButton, 0);
                });
            }

            $(window).off("resize.cgFloatingATCViewport orientationchange.cgFloatingATCViewport").on("resize.cgFloatingATCViewport orientationchange.cgFloatingATCViewport", function() {
                setTimeout(observeCurrentButton, 0);
            });

            floatingBtn.off("click.cgFloatingATC").on("click.cgFloatingATC", function(e) {
                e.preventDefault();
                var originalBtn = findOriginalBtn();

                if (!originalBtn.length || originalBtn.is(":disabled") || originalBtn.attr("aria-disabled") === "true") {
                    return false;
                }

                var originalForm = originalBtn.closest("form").get(0);

                if (originalForm && typeof originalForm.requestSubmit === "function") {
                    originalForm.requestSubmit(originalBtn.get(0));
                } else {
                    originalBtn.trigger("click");
                }

                return false;
            });
        }
    }


};

$(document).ready(function(){
    CgProduct.init();
});

// Shopify re-renders a section's markup without reloading the page — the Theme
// Editor does it after every change, and `shopify theme dev` does it on sync.
// The replacement HTML is fresh from the server, so the gallery arrives
// un-initialized: no Slick, no thumbnail wiring, just the raw markup, which looks
// like the theme's original slider. Re-run the gallery setup whenever that
// happens, or the gallery silently reverts a few seconds after load.
document.addEventListener("shopify:section:load", function(event){
    var section = event.target;
    if(!section || typeof section.querySelector !== "function") {
        return;
    }
    if(!section.querySelector("media-gallery")) {
        return;
    }

    CgProduct.initSlider();
    CgProduct.initMobileGalleryCounter();
});
